import { SubmitAiBatchForm } from "../../../interfaces/AiBatchObject";
import { turboField } from "../../helpers/TurboStore";

/**
 * Submit form → POST /api/v1/imagegen/batches body.
 *
 * Optional fields are left OFF the body rather than sent empty: a blank
 * `instructions` is "no creative direction", and an absent `format` is what
 * tells the server to use the functionality's default shape.
 */
export function buildSubmitAiBatchPayload(form: SubmitAiBatchForm): SubmitAiBatchForm {
  const instructions = form.instructions?.trim();
  return {
    businessId: form.businessId,
    collectionId: form.collectionId,
    functionality: form.functionality,
    ...(instructions ? { instructions } : {}),
    ...(form.format ? { format: form.format } : {}),
    ...turboField(form.businessId),
  };
}

export default { buildSubmitAiBatchPayload };
